function loadPostHog() {
  // prettier-ignore
  !function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="Mi Ri init Vi Gi Rr Wi Ji Bi capture calculateEventProperties tn register register_once register_for_session unregister unregister_for_session an getFeatureFlag getFeatureFlagPayload getFeatureFlagResult isFeatureEnabled reloadFeatureFlags updateFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey cancelPendingSurvey canRenderSurvey canRenderSurveyAsync un identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset setIdentity clearIdentity get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException addExceptionStep captureLog startExceptionAutocapture stopExceptionAutocapture loadToolbar get_property getSessionProperty nn Xi createPersonProfile setInternalOrTestUser sn Hi cn opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing Ki debug Lr rn getPageViewId captureTraceFeedback captureTraceMetric Di".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
  // prettier-ignore
  posthog.init('phc_7CgLoetviGa7GLXDemc16kZquIASNBqxoPemzhJSqkb', {
    api_host: 'https://eu.i.posthog.com',
    defaults: '2026-01-30',
    capture_performance: true,
    session_idle_timeout_seconds: 14400,
    before_send: (event) => {
      if (!event) return event;
      const props = event.properties;

      // Menu mobile: accetta solo gli eventi emessi dal blocco in fondo a questo file.
      // Scarta quelli del vecchio codice ancora presente in theme.min.js.
      // Il desktop (device_type: 'desktop') non viene toccato.
      const MENU_EVENTS = ['menu_dropdown_open', 'menu_dropdown_link_click'];
      if (
        MENU_EVENTS.includes(event.event) &&
        props.device_type === 'mobile' &&
        props.tracker !== 'posthog_js'
      ) {
        return null;
      }
      const ref = props.$referring_domain;
      const STORAGE_KEY = 'ph_real_channel';
      const TTL_MS = 30 * 24 * 60 * 60 * 1000;

      const isRealReferrer = ref
        && ref !== '$direct'
        && !ref.includes('tannico.it');

      if (isRealReferrer) {
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify({
            referring_domain: ref,
            referrer: props.$referrer || '',
            utm_source: props.$utm_source || '',
            utm_medium: props.$utm_medium || '',
            utm_campaign: props.$utm_campaign || '',
            saved_at: Date.now()
          }));
        } catch (e) {}
      }

      if (ref?.includes('tannico.it')) {
        try {
          const raw = localStorage.getItem(STORAGE_KEY);
          if (raw) {
            const saved = JSON.parse(raw);
            if (Date.now() - saved.saved_at < TTL_MS) {
              props.$referring_domain = saved.referring_domain;
              props.$referrer = saved.referrer;
              if (saved.utm_source) props.$utm_source = saved.utm_source;
              if (saved.utm_medium) props.$utm_medium = saved.utm_medium;
              if (saved.utm_campaign) props.$utm_campaign = saved.utm_campaign;
            } else {
              localStorage.removeItem(STORAGE_KEY);
            }
          }
        } catch (e) {}
      }

      return event;
    }
  });

  posthog.register({
    theme_name: Shopify.theme.name,
  });

  posthog.onFeatureFlags(function (flags, flagVariants, { errorsLoading }) {
    const PREFIX = "ph_flag_";
    function setCookie(name, value) {
      var date = new Date();
      date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
      document.cookie =
        name +
        "=" +
        value +
        "; expires=" +
        date.toUTCString() +
        "; path=/; SameSite=Lax";
    }
    for (const [key, flag] of Object.entries(flags)) {
      const enabled = posthog.getFeatureFlag(flag) == "test";
      setCookie(PREFIX + flag, enabled ? "true" : "false");
      if (enabled) {
        document.documentElement.classList.add(flag);
      }
    }
  });
}

document.addEventListener("visitorConsentCollected", (event) => {
  if (event.detail.analyticsAllowed) {
    if (!window.posthog) {
      loadPostHog();
    }
  }
});

window.Shopify?.loadFeatures?.(
  [{ name: "consent-tracking-api", version: "0.1" }],
  (error) => {
    if (error) {
      return;
    }
    if (
      window.Shopify?.customerPrivacy &&
      window.Shopify.customerPrivacy.analyticsProcessingAllowed()
    ) {
      if (!window.posthog) {
        loadPostHog();
      }
    }
  },
);

// ============================================================
// Tracking Product AI Assistant (Doofinder) — click su pill e CTA
// Listener delegato unico. Se PostHog non è caricato (no consenso),
// non traccia. Copre trigger PDP e pill in chat.
// ============================================================
document.addEventListener(
  "click",
  function (e) {
    if (!window.posthog) return;

    const pill = e.target.closest(
      ".product-ai-widget-question, .dfd-ai-hint-pill",
    );
    const cta = e.target.closest(
      "#product-ai-widget-trigger, .product-ai-widget-cta",
    );

    if (pill) {
      window.posthog.capture("ai_assistant_pill_click", {
        question: pill.getAttribute("data-message") || pill.textContent.trim(),
        surface: pill.classList.contains("dfd-ai-hint-pill")
          ? "chat"
          : "trigger",
      });
    } else if (cta) {
      window.posthog.capture("ai_assistant_open", {
        source: "fai_una_domanda",
      });
    }
  },
  true,
);

// ============================================================
// Tracking Menu mobile (header-drawer) — open pannelli e click link
// Contratto col Liquid: i <summary> che aprono un pannello hanno data-title.
// Se PostHog non è caricato (no consenso), non traccia.
// ============================================================
(function () {
  const ROOT_ID = "Details-menu-drawer-container";

  // Etichetta pulita: data-title se presente, altrimenti testo senza SVG/immagini
  function getLabel(el) {
    if (!el) return null;
    if (el.dataset.title) return el.dataset.title.trim();
    const clone = el.cloneNode(true);
    clone
      .querySelectorAll("svg, img, [aria-hidden='true']")
      .forEach((n) => n.remove());
    const text = clone.textContent.replace(/\s+/g, " ").trim();
    return text ? text.slice(0, 100) : null;
  }

  // <details> genitore, escluso il details radice del drawer (hamburger)
  function getParentDetails(el) {
    const parent = el.parentElement?.closest("details");
    return parent && parent.id !== ROOT_ID ? parent : null;
  }

  // 1 = categoria, 2 = sottocategoria
  function getLevel(details) {
    let level = 1;
    let ancestor = getParentDetails(details);
    while (ancestor) {
      level++;
      ancestor = getParentDetails(ancestor);
    }
    return level;
  }

  document.addEventListener(
    "click",
    function (e) {
      if (!window.posthog) return;
      if (!e.target.closest("header-drawer")) return;

      // Apertura pannello
      const summary = e.target.closest("summary[data-title]");
      if (summary) {
        const details = summary.parentElement;
        const parent = getParentDetails(details);
        window.posthog.capture("menu_dropdown_open", {
          panel_title: getLabel(summary),
          panel_level: getLevel(details),
          parent_menu: parent
            ? getLabel(parent.querySelector(":scope > summary"))
            : null,
          device_type: "mobile",
          tracker: "posthog_js",
        });
        return;
      }

      // Click su link di navigazione (esclude logo, carosello highlights, footer)
      const link = e.target.closest("a[href]");
      if (!link || !link.closest(".menu-drawer__navigation")) return;

      const panel = link.closest("details");
      const inPanel = panel && panel.id !== ROOT_ID;
      window.posthog.capture("menu_dropdown_link_click", {
        link_label: getLabel(link),
        link_url: link.getAttribute("href"),
        parent_menu: inPanel
          ? getLabel(panel.querySelector(":scope > summary"))
          : null,
        panel_level: inPanel ? getLevel(panel) : null,
        device_type: "mobile",
        tracker: "posthog_js",
      });
    },
    true,
  );
})();

// ============================================================
// Menu desktop (blocks/_header-menu.liquid): hover sulle voci di primo livello e click nei sottomenu
// ============================================================
(function () {
  let lastTitle;
  let hoverTimer;

  const ITEM = "header-menu li[data-link-title]";
  const isItem = (el) => el instanceof Element && el.matches(ITEM);

  // pointerenter/pointerleave non fanno bubbling: in capture arrivano comunque al document
  document.addEventListener(
    "pointerenter",
    function (e) {
      if (!isItem(e.target)) return;
      const item = e.target;
      const title = item.dataset.linkTitle;
      if (title === lastTitle) return;
      lastTitle = title;

      // Evento solo dopo una sosta: filtra il mouse che attraversa il menu
      clearTimeout(hoverTimer);
      const hasDropdown = !!item.querySelector("[ref='submenu[]']");
      hoverTimer = setTimeout(function () {
        if (!window.posthog) return;
        window.posthog.capture("menu_item_hover", {
          menu_label: title,
          has_dropdown: hasDropdown,
          device_type: "desktop",
        });
      }, 450);
    },
    true,
  );

  document.addEventListener(
    "pointerleave",
    function (e) {
      if (isItem(e.target)) clearTimeout(hoverTimer);
    },
    true,
  );

  document.addEventListener("click", function (e) {
    if (!window.posthog) return;
    const link = e.target.closest("header-menu [ref='submenu[]'] a[href]");
    if (!link) return;
    window.posthog.capture("menu_dropdown_link_click", {
      link_label: link.textContent.trim(),
      link_url: link.getAttribute("href"),
      parent_menu: link.closest("[ref='submenu[]']").dataset.linkTitle || null,
      device_type: "desktop",
    });
  });
})();

// ============================================================
// Click sulle card dei caroselli home (snippets/product-card-gallery.liquid, con tracking_label):
// i dati stanno negli attributi data-track-* della slide e del carosello
// ============================================================
document.addEventListener("click", function (e) {
  if (!window.posthog) return;
  const slide = e.target.closest("[data-track-carousel] [data-track-id]");
  if (!slide) return;
  const carousel = slide.closest("[data-track-carousel]").dataset;
  const d = slide.dataset;
  window.posthog.capture("hp_carousel_card_click", {
    product_id: Number(d.trackId),
    product_title: d.trackTitle,
    product_handle: d.trackHandle,
    product_sku: d.trackSku || null,
    product_url: d.trackUrl,
    product_vendor: d.trackVendor,
    product_price: Number(d.trackPrice),
    position: Number(d.trackPosition),
    carousel: carousel.trackCarousel,
    card_variant: carousel.trackCardVariant,
    click_target: e.target.closest("button") ? "button" : "card",
  });
});

// ============================================================
// Add to cart dalle card dei caroselli (snippets/plp-card-product-carousel.liquid): metrica dell'A/B test
// "plp-volume-discount-price", la variante del flag la aggiunge PostHog all'evento
// ============================================================
document.addEventListener("click", function (e) {
  if (!window.posthog || !e.target.closest("button")) return;
  const wrap = e.target.closest("[data-track-atc-id]");
  if (!wrap) return;
  const d = wrap.dataset;
  window.posthog.capture("card_add_to_cart", {
    product_id: Number(d.trackAtcId),
    product_handle: d.trackAtcHandle,
    product_price: Number(d.trackAtcPrice),
    volume_offer: "trackAtcVolumeOffer" in d,
    card: "carousel",
  });
});

// ============================================================
// PATCH per assets/posthog.js: incolla TUTTO in fondo al file.
// Se PostHog non è caricato (nessun consenso analytics), non traccia nulla.
// ============================================================

// ------------------------------------------------------------
// 1) Microsito box (template page.box-microsite)
// box-microsite emette eventi DOM "box:track" con { event, props }.
// I cambi di vino (?vino=slug) generano già $pageview in automatico.
// Eventi: box_wine_view, box_tab_open, box_curiosity_more, box_dare_open,
// box_timer_start, box_wine_tasted, box_map_pin, box_menu_open,
// box_quiz_answer, box_quiz_complete, box_reorder_click,
// box_card_view, box_card_name_set, box_card_download, box_card_share
// Tutti hanno la proprietà "box" (rossi-qp, nebbiolo, bianchi).
// ------------------------------------------------------------
document.addEventListener("box:track", function (e) {
  if (!window.posthog || !e.detail || !e.detail.event) return;
  window.posthog.capture(
    e.detail.event,
    Object.assign({ tracker: "posthog_js" }, e.detail.props || {}),
  );
});

// ------------------------------------------------------------
// 2) PDP dei bundle: card "Cosa c'è nella box" (snippet box-bonus)
// box_pdp_bonus_view: la card è entrata a schermo per almeno metà (1 volta per pagina).
// box_pdp_bonus_open: il cliente apre "Scopri cosa include".
// Proprietà "box": handle della pagina microsito, oppure "bundle" se senza guida.
// ------------------------------------------------------------
(function () {
  function init() {
    var el = document.querySelector("[data-box-bonus]");
    if (!el) return;
    var box = el.getAttribute("data-box-bonus");
    if ("IntersectionObserver" in window) {
      // PostHog si carica dopo il controllo del consenso: se la card è già a schermo prima,
      // si riprova finché PostHog c'è (max ~10 s). Senza consenso PostHog non arriva e non si traccia.
      var seen = false,
        sent = false,
        tries = 0;
      var send = function () {
        if (sent) return;
        if (window.posthog && typeof window.posthog.capture === "function") {
          sent = true;
          window.posthog.capture("box_pdp_bonus_view", {
            box: box,
            tracker: "posthog_js",
          });
        } else if (++tries < 20) {
          setTimeout(send, 500);
        }
      };
      var io = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting || seen) return;
          seen = true;
          io.disconnect();
          send();
        },
        { threshold: 0.5 },
      );
      io.observe(el);
    }
    el.addEventListener(
      "toggle",
      function (ev) {
        var d = ev.target;
        if (d.tagName === "DETAILS" && d.open && window.posthog) {
          window.posthog.capture("box_pdp_bonus_open", {
            box: box,
            section: d.closest(".bx__guide") ? "guida" : "vini",
            tracker: "posthog_js",
          });
        }
      },
      true,
    );
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();
})();
